import { APIPromise } from "services/HttpService";
import { ApiDefinition } from "./ApiDefinition";
import { AcknowledgeResponse, AlertDTO, ClearExpiredResponse } from "./model/alerts/alert-types";

class AlertsApiDefinition extends ApiDefinition {
  constructor() {
    super("/alerts");
  }

  async getCurrentAlerts(): APIPromise<AlertDTO[]> {
    return this.get("current");
  }

  async acknowledgeAlert(alertId: number): APIPromise<AcknowledgeResponse> {
    return this.post(`${alertId}/ack`);
  }

  async unacknowledgeAlert(alertId: number): APIPromise<AcknowledgeResponse> {
    return this.delete(`${alertId}/ack`);
  }

  async getAlertHistory(companyRef: string): APIPromise<AlertDTO[]> {
    return this.get(`history/${companyRef}`);
  }

  async clearExpiredAlerts(): APIPromise<ClearExpiredResponse> {
    return this.delete("expired");
  }
}

const AlertsApi = new AlertsApiDefinition();
export default AlertsApi;
